
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    memberPerformanceofflinePerformanceImpotRecord,
  } from "@/api/statistic"
  import axios from 'axios';
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0

    private mounted () {
      this.gettablelist()
    }


//  //导出导入结果
    private async download(row){
      try{
        this.tableloading = true
        let res:any = await axios.get('/pc/memberPerformance/offlinePerformanceImportResultExport'+`?RecordId=${row.Id}&IsExport=true`,{
          responseType:'blob',
        })
				if(res.status==200){
          let blob = new Blob([res.data],{type:"application/octet-stream; charset=utf-8"})
					let a = document.createElement('a')
					a.style.display = 'none'
					a.download = `${row.TypeValue}反馈表格.xlsx`
					a.href = URL.createObjectURL(blob)
					a.click()
					a.remove()
				}else{
					this.$message.error(res.data.Message)
				}
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.changePage(1)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.filterTime = ''
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await memberPerformanceofflinePerformanceImpotRecord({
          Keywords:this.keywords,
          Time:this.filterTime,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
